/**
 * @description 环境配置文件
 * @date 2019-07-30
 */

const localDoaminPortH5 = window.location.origin || 'http://localhost:8080'
const localMainDomain = window.location.hostname || 'localhost'
const configHost = {
  LOCAL: {
    mainDomain: localMainDomain,
    domain: localDoaminPortH5,
    smtDomain: 'https://servicedev.yflife.app'
  },
  DEV: {
    mainDomain: 'reotest.com',
    domain: 'http://ins.reotest.com',
    smtDomain: 'http://ins.reotest.com'
  },
  DEV2: {
    mainDomain: 'yflife.app',
    domain: 'https://cxdev.yflife.app',
    smtDomain: 'https://servicedev.yflife.app'
  },
  SIT: {
    mainDomain: 'yflife.app',
    domain: 'https://cxsit.yflife.app',
    smtDomain: 'https://servicesit.yflife.app'
  },
  UAT: {
    mainDomain: 'yflife.app',
    domain: 'https://cxuat.yflife.app',
    smtDomain: 'https://serviceuat.yflife.app'
  },
  Live: {
    mainDomain: 'yflife.app',
    domain: 'https://cx.yflife.app',
    smtDomain: 'https://service.yflife.app'
  },
  WebUAT: {
    mainDomain: 'yflife.app',
    domain: 'https://cxuat.yflife.app',
    webDomain: 'https://cxweb-uat.yflife.app',
    smtDomain: 'https://serviceuat.yflife.app',
    cust360Domain: 'https://api-gateway-uat.yflife.app/cust360',
    cust360ApiKey: 'D7NOfzCB1YjoA+setJXaAo8mDZfDKbyBSS7Db4mtBuK50LPRwriNZA=='
  },
  WebLive: {
    mainDomain: 'yflife.app',
    domain: 'https://cx.yflife.app',
    webDomain: 'https://cxweb.yflife.app',
    smtDomain: 'https://service.yflife.app',
    cust360Domain: 'https://api-gateway.yflife.app/cust360',
    cust360ApiKey: 'K4mCAKU/sfeIactWKMzMorn06MX/9RXVNtUQvXFM5gTMirz78kIw4g=='
  }
}
const env = getCurEnv(configHost)
const currentHost = configHost[env]

// 判断当前环境
function getCurEnv (configHost) {
  const currDomain = location.origin
  let currentEnv = 'LOCAL'
  for (const env in configHost) {
    if (configHost.hasOwnProperty(env)) {
      const domain = configHost[env].domain
      const webDomain = configHost[env].webDomain
      if (currDomain === domain || currDomain === webDomain) {
        currentEnv = env
      }
    }
  }
  return currentEnv
}

export default {
  domain: currentHost.domain,
  mainDomain: currentHost.mainDomain,
  env,
  smtDomain: currentHost.smtDomain,
  webDomain: currentHost.webDomain,
  cust360Domain: currentHost.cust360Domain,
  cust360ApiKey: currentHost.cust360ApiKey
}
